<!--角色管理-->
<template>
  <Page class="queryView">
    <div>
      <div class="pageContent-title">角色列表</div>
      <div class="queryView-actions">
        <a-button class="app-btn" @click="addRow">
          <app-icon type="icon-tianjia"></app-icon>
          添加新角色
        </a-button>
      </div>
      <div class="queryView-main">
        <!-- :scroll="{ x: 1400 }" -->
        <a-table
          class="mt-5"
          :rowKey="
            (record, index) => {
              return index
            }
          "
          bordered
          :loading="tableLoading"
          :columns="tableColumns"
          :dataSource="dataSource"
          @change="handleTableChange$qv"
          :pagination="{
            current: pageNumber,
            pageSize: pageSize,
            total: countTotal,
            showSizeChanger: true,
            showQuickJumper: true,
          }"
        ></a-table>
      </div>
    </div>
    <a-modal :title="modal.title" v-model="modal.visible" :width="700" @ok="handleOk" @cancel="handleCancel">
      <div class="pb-20">
        <a-form :form="modal.form" class="flex-form">
          <a-form-item label="角色名称">
            <a-input
              v-decorator="[
                'name',
                {
                  rules: [{ required: true, message: '请输入角色名称' }],
                },
              ]"
              placeholder="请输入角色名称"
            ></a-input>
          </a-form-item>
        </a-form>
      </div>
    </a-modal>
    <SetPower ref="setPower"></SetPower>
  </Page>
</template>

<script>
import Page from '@/components/Page'
import { queryViewMixin, toolMixin } from '@/utils/mixin'
import PictureCardUpload from '@/components/pictureCardUpload/PictureCardUpload.vue'
import SetPower from './modules/SetPower.vue'
export default {
  mixins: [queryViewMixin, toolMixin],
  data() {
    const tableColumns = [
      {
        title: '序号',
        width: '8%',
        align: 'center',
        customRender: (text, row, index) => {
          return <span> {index + 1} </span>
        },
      },
      {
        title: '角色',
        width: '50%',
        align: 'center',
        dataIndex: 'name',
      },
      {
        title: '权限',
        width: '25%',
        align: 'center',
        dataIndex: 'isAuth',
        customRender: (text, row) => {
          return (
            <div>
              <span
                class="cursor-pointer"
                onClick={() => {
                  this.setPower(row)
                }}
              >
                配置权限
              </span>
            </div>
          )
        },
      },
      {
        title: '操作',
        width: '20%',
        align: 'center',
        customRender: (text, row) => {
          return (
            <div class="flex gap-5 justify-center text-primary-500">
              <span
                type="icon-bianji"
                class="cursor-pointer"
                onClick={() => {
                  this.editRow(row)
                }}
              >编辑</span>
              {row.roleId != 1 && (
                <span
                  type="icon-shanchu"
                  class="cursor-pointer"
                  onClick={() => {
                    this.removeRow(row)
                  }}
                >删除</span>
              )}
            </div>
          )
        },
      },
    ]
    return {
      form: this.$form.createForm(this),
      tableLoading: false,
      tableColumns: tableColumns,
      pageNumber: 1,
      pageSize: 10,
      countTotal: 0,
      modal: {
        visible: false,
        form: this.$form.createForm(this),
        data: {},
      },
      dataSource: [],
    }
  },
  components: {
    Page,
    PictureCardUpload,
    SetPower,
  },
  computed: {
    typesMap() {
      return {
        isAuth: [
          { value: 1, label: '已配置' },
          { value: 0, label: '未配置' },
        ],
      }
    },
  },
  methods: {
    async doQuery() {
      const res = await this.$axios.get('/user/admin/permission/role', {
        params: { page: this.pageNumber, limit: this.pageSize },
      })
      if (res.success) {
        this.dataSource = res.data
        this.countTotal = Number(res.count)
      }
    },
    addRow() {
      this.resetModal$t()
      this.modal.title = '新增角色'
      this.modal.visible = true
    },
    editRow(row) {
      this.resetModal$t()
      this.modal.visible = true
      this.modal.data = row
      this.modal.title = '编辑角色'
      this.safeSetFieldsValue$t(this.modal.form, row)
    },
    async removeRow(row) {
      await new Promise((resolve, reject) => {
        this.$confirm({
          title: '提示',
          content: '确定删除?',
          onOk: () => {
            resolve()
          },
          onCancel: () => {
            reject(new Error('E_CANCEL'))
          },
        })
      })
      await this.$axios.delete('/user/admin/permission/role?roleId=' + row.roleId, {})
      this.$message.success('操作成功')
      this.doQuery()
    },
    handleCancel() {
      this.modal.visible = false
    },
    handleOk() {
      this.modal.form.validateFields(async (errors, values) => {
        if (!errors) {
          const params = values
          try {
            await this.$axios.post('/user/admin/permission/role', {
              roleId: this.modal.data.roleId,
              ...params,
            })
            this.$message.success('操作成功!')
            this.modal.visible = false
            this.doQuery()
          } catch (e) {
            console.error(e)
          }
        }
      })
    },
    async setPower(row) {
      await this.$refs.setPower.start(row)
      this.$message.success('操作成功')
      this.doQuery()
    },
  },
  mounted() {
    this.doQuery()
  },
}
</script>

<style lang="less" scoped></style>
